'use strict';

var _slicedToArray = require("/home/runner/work/tba-web/tba-web/node_modules/@babel/runtime/helpers/slicedToArray");
var _classCallCheck = require("/home/runner/work/tba-web/tba-web/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/runner/work/tba-web/tba-web/node_modules/@babel/runtime/helpers/createClass");
var MapGenerator = require('./map-generator');
var stringify = require('./stringify');
var warnOnce = require('./warn-once');
var parse = require('./parse');
var Result = require('./result');
var NoWorkResult = /*#__PURE__*/function (_Symbol$toStringTag) {
  function NoWorkResult(processor, css, opts) {
    _classCallCheck(this, NoWorkResult);
    css = css.toString();
    this.stringified = false;
    this._processor = processor;
    this._css = css;
    this._opts = opts;
    this._map = undefined;
    var root;
    var str = stringify;
    this.result = new Result(this._processor, root, this._opts);
    this.result.css = css;
    var self = this;
    Object.defineProperty(this.result, 'root', {
      get: function get() {
        return self.root;
      }
    });
    var map = new MapGenerator(str, root, this._opts, css);
    if (map.isMap()) {
      var _map$generate = map.generate(),
        _map$generate2 = _slicedToArray(_map$generate, 2),
        generatedCSS = _map$generate2[0],
        generatedMap = _map$generate2[1];
      if (generatedCSS) {
        this.result.css = generatedCSS;
      }
      if (generatedMap) {
        this.result.map = generatedMap;
      }
    }
  }
  _createClass(NoWorkResult, [{
    key: _Symbol$toStringTag,
    get: function get() {
      return 'NoWorkResult';
    }
  }, {
    key: "processor",
    get: function get() {
      return this.result.processor;
    }
  }, {
    key: "opts",
    get: function get() {
      return this.result.opts;
    }
  }, {
    key: "css",
    get: function get() {
      return this.result.css;
    }
  }, {
    key: "content",
    get: function get() {
      return this.result.css;
    }
  }, {
    key: "map",
    get: function get() {
      return this.result.map;
    }
  }, {
    key: "root",
    get: function get() {
      if (this._root) {
        return this._root;
      }
      var root;
      var parser = parse;
      try {
        root = parser(this._css, this._opts);
      } catch (error) {
        this.error = error;
      }
      this._root = root;
      return root;
    }
  }, {
    key: "messages",
    get: function get() {
      return [];
    }
  }, {
    key: "warnings",
    value: function warnings() {
      return [];
    }
  }, {
    key: "toString",
    value: function toString() {
      return this._css;
    }
  }, {
    key: "then",
    value: function then(onFulfilled, onRejected) {
      if (process.env.NODE_ENV !== 'production') {
        if (!('from' in this._opts)) {
          warnOnce('Without `from` option PostCSS could generate wrong source map ' + 'and will not find Browserslist config. Set it to CSS file path ' + 'or to `undefined` to prevent this warning.');
        }
      }
      return this.async().then(onFulfilled, onRejected);
    }
  }, {
    key: "catch",
    value: function _catch(onRejected) {
      return this.async().catch(onRejected);
    }
  }, {
    key: "finally",
    value: function _finally(onFinally) {
      return this.async().then(onFinally, onFinally);
    }
  }, {
    key: "async",
    value: function async() {
      if (this.error) return Promise.reject(this.error);
      return Promise.resolve(this.result);
    }
  }, {
    key: "sync",
    value: function sync() {
      if (this.error) throw this.error;
      return this.result;
    }
  }]);
  return NoWorkResult;
}(Symbol.toStringTag);
module.exports = NoWorkResult;
NoWorkResult.default = NoWorkResult;